var _g, _radialGradient, _path, _radialGradient2, _path2, _linearGradient, _path3, _radialGradient3, _path4, _radialGradient4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalySuperenalotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.16 15.43-2.27.83S6.36 14.96 5.6 15c-.75.03-1.12.68-.86 1.21s.79.75 1.88.8 2.55.16 3.21 1.35.82 3.02.2 4.14-3.08 2.23-4.78 1.44-2.01-2.42-2.01-2.42l2.15-1.02s.52 1.66 1.68 1.74c1.17.08 1.61-1.57.51-2.3-1.1-.72-3.67.05-4.63-1.88s-.17-3.24.37-3.84c1.5-1.62 5.15-1.53 5.84 1.21z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.13 24.32 17.44 14.1l2.07-.59.28 1.53c.88-2.15 2.86-2.82 4.09-.2.85 1.81.71 4.26.23 5.33-.64 1.41-2.51 1.21-3.37.12l.69 3.81-2.3.22zm.93-7.79.32 1.77c1.25 1.66 2.4 1.14 2.14-.94-.13-1.04-.79-2.28-1.52-2.14-.55.1-.83.91-.94 1.31zm11.92-.12-4.55.44s.28 1.72 1.31 1.75c1.02.02 1.21-.93 1.21-.93l1.99-.11s-.42 2.37-3.07 2.52c-2.65.14-3.67-1.88-3.73-3.76-.19-5.19 6.69-6.41 6.84.09zm-2.26-1.08-2.43.32s-.34-1.11.36-1.7 1.8-.25 2.07 1.38z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 18.91-.29-10.55 6.67-.24.04 2.24-4.17.11.1 1.92 3.81-.29.04 2.18-3.87.08-.02 2.33 4.3-.17.03 2.39zm7.64.03.33-7.65 2.1-.24-.02 1.63c.29-.44.73-.97 1.24-1.28.96-.57 1.98-.29 2.44.53.5.9.31 3.97.15 6.92l-2.23.02c-.01 0 .1-2.19.08-3.68-.02-1.31-.09-1.94-.66-1.98-.49-.03-.69.3-.92.75l-.18 4.98h-2.33zm7.65-5.42 2 .53s.22-.92 1.1-.92 1.11 1.22 1.11 1.22-.4.66-1.98.73c-1.59.07-2.32.87-2.57 1.66s-.11 1.77.34 2.21 1.13.71 1.94.61c.82-.11 1.84-.87 1.84-.87s-.05.14.06.5c.11.37.21.37.21.37l1.85.09s-.19-.74.02-2.68c.22-1.94.44-3.9-.55-4.9-.96-1.01-4.24-1.15-5.37 1.45zm3.8 2.25s-1.52.18-1.94.88c-.43.7.21 1.65 1.02 1.48 1.01-.2 1.43-1.53.92-2.36zm3.1 4.05 1.25-10.53 2.14-.02-1.11 10.72zm4.16-4.87c-.62 1.49-.61 3.08 0 4.38.75 1.61 3.14 1.85 4.35.89s1.39-1.96 1.6-2.73c.19-.72.51-3.7-1.56-4.65-1.91-.88-3.65.33-4.39 2.11zm1.63 2.01c-.06 1.2.45 1.83 1.07 1.89 1.4.15 1.47-2.63 1.11-3.54-.37-.95-1.1-.86-1.56-.37-.43.46-.58 1.28-.62 2.02zm14.89 1.09c-.75 1.43-.87 3.01-.38 4.35.61 1.65 2.97 2.08 4.26 1.23 1.29-.86 1.56-1.84 1.82-2.59.25-.7.83-3.63-1.15-4.74-1.82-1.02-3.66.05-4.55 1.75zm1.45 2.12c-.17 1.19.3 1.86.9 1.96 1.38.25 1.69-2.5 1.41-3.43-.24-.83-1.01-.86-1.5-.42-.47.45-.71 1.17-.81 1.89z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.62 14.15c1.04-2.47-.33-5.36-3.19-5.05-1-2.1-4.55-1.76-5.46.39-2.37-1.16-5.23.54-5.08 3.34-.43.14-.67.46-.87.85l3.09 8.54c.4.47.89 1.16 1.47 1.12 1.08 2.13 5.09 1.82 5.72-.52 2.1 1.35 5.18-.27 4.89-2.89 2.12-1.23 1.84-4.7-.57-5.78z",
    opacity: 0.3,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.04 13.48c1.04-2.47-.33-5.36-3.19-5.05-1-2.1-4.55-1.76-5.46.39-2.37-1.16-5.23.54-5.08 3.34-.43.14-.67.46-.87.85l2.38 8.95-.04.47c.12-.09.26-.17.37-.27.4.47 1.27.55 1.85.51 1.08 2.13 5.09 1.82 5.72-.52 2.1 1.35 5.18-.27 4.89-2.89 2.12-1.23 1.84-4.7-.57-5.78zM31.88 17.6l2.07.98s3.18-.8 3.76-.54 1.21-6.23-.84-6.79-4.47.61-4.47.61l-.52 5.74zm41.62-3.29 2.15.34-.96 4.59-11.11-2.43 1.43-4.26z",
    fill: "#186bb2"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 92.998,
    cy: 9.404,
    r: 4.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#fbfceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#eff7e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#dcefd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#c0e4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#9dd5ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7ec898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#2d9649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#2d9248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c8d46"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.31 9.62c2.1-.79 3.67 1.44 2.87 3.04-.66 1.34-3.14 1.78-5.61 2.48-.93-2.4-2.07-4.65-1.41-6 .81-1.6 3.54-1.7 4.15.48z",
    fill: "url(#e)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 89.743,
    cy: 8.596,
    r: 3.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#fbfceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#eff7e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#dcefd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#c0e4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#9dd5ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7ec898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#2d9649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#2d9248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c8d46"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.31 9.62c-.85 2.29-.27 4.82-2.73 5.52-.93-2.4-2.07-4.65-1.41-6 .8-1.6 3.53-1.7 4.14.48z",
    fill: "url(#f)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 86.718,
    y1: 16.836,
    x2: 89.271,
    y2: 21.941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#fbfceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#eff6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#dcedd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#c0dfbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#9dcda1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#71b87f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#3f9f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#2d9649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#2d9248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c8d46"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.43 21.48c.64 2.16 3.35 2.08 4.14.48.66-1.34-.48-3.59-1.41-6-2.47.7-4.94 1.13-5.61 2.48-.78 1.6.79 3.85 2.88 3.04z",
    fill: "url(#g)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 83.794,
    cy: 13.329,
    r: 5.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#fffeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#7ec898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#95d1a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#cfeace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fffeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fbfceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#f0f7e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#ddedd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#c3e0bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#a1d0a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#78bb84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#47a35e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#2d9649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#2d9248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#2c8d46"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.48 12.59c-.79-2.11 1.43-3.69 3.02-2.89 1.33.67 1.77 3.16 2.46 5.64-2.39.94-4.62 2.09-5.96 1.42-1.59-.8-1.68-3.55.48-4.17z",
    fill: "url(#h)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 91.903,
    cy: 16.103,
    r: 6.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffeee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#fbfceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#eff7e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#dcefd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#c0e4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#9dd5ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7ec898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#2d9649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#2d9248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#2c8d46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#2d9649"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.27 18.51c2.15-.64 2.07-3.37.48-4.17-1.33-.67-3.57.48-5.96 1.42.69 2.48 1.12 4.97 2.46 5.64 1.59.79 3.83-.78 3.02-2.89z",
    fill: "url(#i)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.18 10.06c1.75-.66 3.05 1.19 2.39 2.53-.55 1.11-2.61 1.48-4.66 2.06-.78-1.99-1.73-3.86-1.17-4.98.66-1.34 2.93-1.41 3.44.39z",
    fill: "#2f9649"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.72 21.19c.52 1.8 2.78 1.73 3.44.4.55-1.11-.4-2.99-1.17-4.98-2.05.58-4.1.94-4.66 2.06-.66 1.33.64 3.2 2.39 2.52zm-2.76-8.41c-.66-1.76 1.18-3.07 2.51-2.4 1.11.55 1.47 2.62 2.05 4.68-1.98.78-3.84 1.73-4.95 1.18-1.33-.66-1.41-2.94.39-3.46z",
    fill: "#2d9649"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.07 18.47c1.79-.53 1.72-2.8.4-3.46-1.11-.56-2.97.39-4.95 1.18.57 2.06.94 4.12 2.05 4.68 1.31.66 3.16-.65 2.5-2.4z",
    fill: "#2f9649"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.99 23.72a.93.93 0 0 1-.91-.77l-.29-1.74-2.11.26c-.04 0-.08.01-.12.01-.08 0-.16-.01-.23-.03-.54.43-1.2.67-1.9.67a3.06 3.06 0 0 1-1.03-.18 3.32 3.32 0 0 1-1.28-.84c-.52 1.06-1.51 1.82-2.97 2.26-.54.16-1.08.25-1.6.25-.64 0-1.24-.12-1.77-.37a4.733 4.733 0 0 1-2.67-3.38c-.09-.42.12-.83.51-1.02l1.04-.49C.49 17.34.29 15.41.41 14.17c.17-1.8 1.49-3.26 3.34-3.73.45-.11.9-.17 1.34-.17 1.76 0 3.18.9 3.9 2.4l2.37-.71c.09-.03.18-.04.26-.04.17 0 .34.05.49.14.07.04.13.09.18.15.08-.06.17-.11.27-.14l2.53-.81c.09-.03.19-.04.28-.04.16 0 .32.04.47.13.01.01.02.01.03.02.04-.02.07-.03.11-.04l2.47-.71c.08-.02.17-.04.25-.04.17 0 .34.05.49.14.04.03.09.06.13.1.5-.36 1.06-.55 1.63-.55.59 0 1.15.2 1.67.6.37.28.68.65.95 1.08.77-1.7 2.25-2.76 3.96-2.84h.21c.99 0 1.86.33 2.56.93v-.02a.91.91 0 0 1 .72-.95l2.45-.54c.07-.01.13-.02.2-.02a.89.89 0 0 1 .5.15c.35-.21.73-.32 1.11-.32.12 0 .25.01.39.04l-.05-1.93c-.01-.5.38-.93.89-.94l7.11-.26a.93.93 0 0 1 .63.25c.18.17.28.41.29.65l.04 2.32c.04-.01.08-.02.13-.02l2.61-.29c.23 0 .45.08.62.24l.12.13c.41-.2.84-.3 1.28-.3.22 0 .44.03.66.08.72.17 1.61.65 1.98 1.92.74-.94 1.74-1.48 3.01-1.66a6.15 6.15 0 0 1 .84-.06c1.47 0 2.58.62 3.2 1.74l.36-3.01a.91.91 0 0 1 .9-.81l2.56-.03a.923.923 0 0 1 .92 1.01l-.39 3.74a4.56 4.56 0 0 1 1.26-1.01 3.99 3.99 0 0 1 1.89-.48c1.25 0 2.41.6 3.15 1.59.13-.31.41-.52.73-.56l.08-.43c.05-.31.27-.58.57-.7.92-.37 1.77-.83 2.76-1.41.14-.09.31-.13.47-.13a.96.96 0 0 1 .54.17c.3.21.44.58.36.94l-.45 2.12.34.05a.98.98 0 0 1 .41.16h.04l.09-.39a.91.91 0 0 1 .57-.65c.87-.33 1.79-.74 2.91-1.3.13-.07.27-.1.41-.1a.88.88 0 0 1 .58.21.92.92 0 0 1 .3.96l-.55 2.02.23.04c.25.04.47.19.61.41.14.21.18.48.12.73l-.09.36c.22-.14.45-.27.69-.38.52-.23 1.07-.34 1.62-.34 1.82 0 3.4 1.27 3.84 3.08.45 1.84-.04 4.09-1.22 5.6-.89 1.13-2.09 1.75-3.4 1.75a4.39 4.39 0 0 1-1.17-.16c-.98-.26-1.75-.81-2.26-1.59-.11.1-.25.17-.41.21-.61.14-1.1.2-1.55.2-1.24 0-2.14-.51-2.59-1.46-.12.18-.31.31-.53.37-.67.17-1.21.26-1.7.26-1.43 0-2.4-.73-2.74-2.07a3.7 3.7 0 0 1-.1-.58c-.23.27-.48.52-.75.74-.66.52-1.54.81-2.48.81a4.25 4.25 0 0 1-.8-.07c-1.09-.2-1.95-.76-2.54-1.61l-.01.08a.93.93 0 0 1-.91.83c-.02 0-2.61-.19-2.61-.19a1.26 1.26 0 0 1-.51-.16l-2.24-.1a1.15 1.15 0 0 1-.78-.37c-.48.22-1.03.38-1.64.38-.35 0-.69-.05-1.03-.16-.49-.15-.91-.41-1.25-.74a.99.99 0 0 1-.53.18l-2.33.02c-.05.01-.1.01-.15.01a1.02 1.02 0 0 1-.71-.29.93.93 0 0 1-.72.35h-2.73a.96.96 0 0 1-.33-.06c-.08.02-.17.04-.25.04h-7.05a.92.92 0 0 1-.92-.9l-.11-4.09c-.05.01-.11.01-.16.01a.95.95 0 0 1-.58-.2l.31 4.59a.93.93 0 0 1-.24.69c-.17.19-.41.29-.66.3l-2.77.04a.93.93 0 0 1-.84-.54c-.83.83-1.99 1.32-3.27 1.32a4.42 4.42 0 0 1-3.17-1.32c-.07.25-.15.48-.25.69-.47 1.04-1.45 1.66-2.61 1.66-.1 0-.19 0-.29-.01l.33 1.84c.05.25-.02.51-.17.72-.16.2-.39.34-.65.36 0-.04-2.77.23-2.8.23zM5.85 19.1c.16.2.3.26.34.27-.06-.12-.18-.2-.34-.27zm76.78-1.16c-.07.2-.13.43-.16.66-.02.14-.02.27-.02.38.04-.12.08-.27.11-.45a4.48 4.48 0 0 0 .07-.59zm-8.97-1.04c.18 0 .37.04.51.12l.32-1.32s-.04-.01-.06-.01-.17 0-.22-.01l-.4-.07c-.1.4-.22.95-.23 1.3.02-.01.05-.01.08-.01zm-53.2-.87c-.01-.19-.04-.42-.11-.67-.01-.03-.02-.05-.02-.08l.13.75zm45.77-1.44c-.05.21-.08.45-.09.69-.01.15 0 .28.02.39.03-.11.05-.25.07-.42a7.26 7.26 0 0 0 0-.66zm-25.75-.81 3.22-.13v-.03a1.57 1.57 0 0 1-.23.04l-2.98.07-.01.05zm11.75-.85z",
    fill: "#186bb2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 14.79c-.19-.46-.62-1.34-1.17-1.32-.93.04-.99 1.04-.16 1.39.79.34 2.02.16 3 .47 1.55.49 2.1 1.92 2.17 3.44.09 1.99-.85 3.14-2.74 3.71-.9.27-1.89.3-2.72-.08a3.85 3.85 0 0 1-2.16-2.72l2.51-1.19c.84 2.62 2.77 1.98 2.47.61-.21-.94-1.3-1.01-2.07-1.09-2.24-.24-3.85-1.24-3.61-3.75.14-1.5 1.24-2.57 2.65-2.92 2.01-.51 3.92.34 4.45 2.48l-2.62.97zm69.12 4.95c-.3-1.36.36-3.34.7-4.73l-.93-.21.83-2.42.69.12.29-1.22c1.03-.39 2.02-.85 3-1.34l-.8 3 1.21.21-.67 2.66-1.21-.27c-.28 1.03-1.33 3.71.54 3.13L78.22 21c-1.36.31-2.93.42-3.3-1.26zm-4.19-5.62-.99-.18.79-2.34.64.09.22-1.27c1.02-.4 1.94-.92 2.89-1.47l-.64 3.09 1.3.18-.56 2.55-1.25-.22c-.23 1.03-1.21 3.88.65 3.24l-.27 2.33c-1.33.34-2.9.51-3.32-1.15-.36-1.36.26-3.42.54-4.85zm8.31 4.37c.14-1.69 1.11-3.57 2.72-4.27 1.79-.78 3.74.22 4.2 2.11.69 2.82-1.24 6.99-4.66 6.08-1.85-.49-2.41-2.16-2.26-3.92zm2.52-.03c-.09.6-.02 1.59.73 1.73.76.14 1.08-.93 1.18-1.51.09-.5.26-2.01-.48-2.19-.91-.21-1.34 1.3-1.43 1.97zm-16.49-7.5c1.73-.92 3.75-.06 4.36 1.78.66 1.97.09 4.6-1.56 5.91-.7.55-1.7.71-2.55.55-3.76-.69-3.12-6.71-.25-8.24zm.15 4.27c-.03.61.12 1.6.88 1.68s.98-.99 1.04-1.56c.05-.52.07-2.16-.7-2.29-.92-.15-1.19 1.51-1.22 2.17zm-4.93-7.88 2.55-.02-1.15 11.16-2.7-.2 1.3-10.94zm-8.25 4.57c.6-1.39 1.53-2.22 3.07-2.43 2.2-.3 3.44.74 3.55 2.92.04.88-.07 1.86-.18 2.84-.11.96-.19 1.94.04 2.88l-2.13-.1c-.25-.01-.4-.51-.44-.71-.86.55-1.76.93-2.78.61-2.39-.74-1.99-4.66 1.4-4.8 1.18-.05 1.63-.42 1.76-.56-.34-1.29-1.52-1.3-1.85 0l-2.44-.65zM56 14.26c-.37.06-1.36.26-1.66.76-.23.37-.07.86.29 1.08.87.53 1.84-.85 1.37-1.84zm-11.2-4.9 2.51-.29-.02 1.23c.61-.74 1.48-1.34 2.48-1.1.9.22 1.28.89 1.41 1.71.29 1.87.02 4.44-.09 6.4l-2.42.02c-.11.06-.21-.1-.21-.22l.08-3.66c0-.29.09-1.74-.47-1.77-.39-.03-.55.29-.71.59l-.18 5.13h-2.73l.35-8.04zm-8.27-2.94 7.08-.26.05 2.66-4.16.12.08 1.49 3.81-.29.05 2.6-3.88.09-.02 1.91 4.3-.17.02 2.82h-7.05l-.28-10.97zm-2.87 3.01.09.91c.67-1 1.63-1.55 2.52-.56l-.63 2.63c-.74-.64-1.16-.44-1.51.57l.33 4.8-2.76.04-.48-7.85 2.44-.54zm-6.95 5.86c.34 1.37 1.75 2.07 2.11.44l2.41-.13c-.58 3.09-4.47 3.96-6.31 1.76-2.03-2.44-.73-7.19 2.66-7.33 2.7-.12 3.6 2.59 3.64 4.83l-4.51.43zm-.22-1.61 2.02-.27c-.46-1.99-2.34-1.42-2.02.27zm-10.25-1.47 2.47-.71.21 1.14c.66-1.15 1.92-2 3.14-1.05 1.69 1.31 2.11 5.08 1.28 6.92-.59 1.3-2.17 1.42-3.25.63l.62 3.41-2.71.26-1.76-10.6zm3.06 2.59.3 1.67c1.49 1.95 2.08.25 1.63-1.36-.42-1.51-1.41-2.13-1.93-.31zm-7.67-1.96c.19 1.24.59 4.36 1.07 5.27.41.79 1.16.47 1.23-.02.03-.2-.01-.5-.11-1.05l-.97-4.1 2.53-.81L17 20.25l-2.43.3-.14-.64c-.61 1.13-1.73 1.51-2.71 1.16-1.09-.39-1.62-1.48-1.83-2.55l-.94-4.88 2.68-.8z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.19 13.69-2.27.83s-.53-1.3-1.29-1.26c-.75.03-1.12.68-.86 1.21s.79.75 1.88.8 2.55.16 3.21 1.35.82 3.02.2 4.14-3.09 2.24-4.8 1.45c-1.7-.79-2.01-2.42-2.01-2.42l2.15-1.02s.52 1.66 1.68 1.74c1.17.08 1.61-1.57.51-2.3-1.1-.72-3.67.05-4.63-1.88s-.17-3.24.37-3.84c1.52-1.63 5.18-1.54 5.86 1.2z",
    fill: "#dc0016"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: -0.97,
    y: -1.74,
    fill: "#df2116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.16 22.58-1.69-10.22 2.07-.59.28 1.53c.88-2.15 2.86-2.82 4.09-.2.85 1.81.71 4.26.23 5.33-.64 1.41-2.51 1.21-3.37.12l.69 3.81-2.3.22zm.93-7.79.32 1.77c1.25 1.66 2.4 1.14 2.14-.94-.13-1.04-.79-2.28-1.52-2.14-.55.1-.83.91-.94 1.31z",
    fill: "#e34c14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.01 14.67-4.55.44s.28 1.72 1.31 1.75c1.02.02 1.21-.93 1.21-.93l1.99-.11s-.42 2.37-3.07 2.52c-2.65.14-3.67-1.88-3.73-3.76-.19-5.19 6.7-6.41 6.84.09zm-2.26-1.08-2.43.32s-.34-1.11.36-1.7c.71-.59 1.8-.25 2.07 1.38z",
    fill: "#e86714"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -0.97,
    y: -1.74,
    fill: "#ea7716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.03 17.17-.29-10.55 6.67-.24.04 2.25-4.17.1.11 1.92 3.8-.29.04 2.18-3.87.08-.02 2.33 4.31-.17.02 2.39z",
    fill: "#ee8a1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.67 17.2 45 9.55l2.1-.24-.02 1.63c.29-.44.73-.97 1.24-1.28.96-.57 1.98-.29 2.44.53.5.9.31 3.97.15 6.92l-2.23.02c-.01 0 .1-2.19.08-3.68-.02-1.31-.09-1.94-.66-1.98-.49-.03-.69.3-.92.75L47 17.2h-2.33z",
    fill: "#f39c23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.32 11.78 2 .53s.22-.92 1.1-.92 1.11 1.22 1.11 1.22-.4.66-1.98.73c-1.59.07-2.32.87-2.57 1.66s-.11 1.77.34 2.21 1.13.71 1.94.61c.82-.11 1.84-.87 1.84-.87s-.05.14.06.5c.11.37.21.37.21.37l1.85.09s-.19-.74.02-2.68c.22-1.94.44-3.9-.55-4.9-.95-1.01-4.24-1.15-5.37 1.45zm3.8 2.25s-1.52.18-1.94.88c-.43.7.21 1.65 1.02 1.48 1.01-.2 1.43-1.53.92-2.36z",
    fill: "#f7ab27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.22 18.08 1.25-10.53 2.14-.02-1.11 10.72z",
    fill: "#f9b92a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38 13.21c-.62 1.49-.61 3.08 0 4.38.75 1.61 3.14 1.85 4.35.89s1.39-1.96 1.6-2.73c.19-.72.51-3.7-1.56-4.65-1.91-.88-3.65.33-4.39 2.11zm1.63 2.01c-.06 1.2.45 1.83 1.07 1.89 1.4.15 1.47-2.63 1.11-3.54-.37-.95-1.1-.86-1.56-.37-.42.46-.58 1.29-.62 2.02z",
    fill: "#fdc22c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9 16.31c-.75 1.43-.87 3.01-.38 4.35.61 1.65 2.97 2.08 4.26 1.23 1.29-.86 1.56-1.84 1.82-2.59.25-.7.83-3.63-1.15-4.74-1.82-1.02-3.66.05-4.55 1.75zm1.45 2.13c-.17 1.19.3 1.86.9 1.96 1.38.25 1.69-2.5 1.41-3.43-.24-.83-1.01-.86-1.5-.42-.47.44-.71 1.16-.81 1.89z",
    fill: "#ffe235"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: -0.97,
    y: -1.74,
    fill: "#fdcf30"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: -0.97,
    y: -1.74,
    fill: "#fed733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39 17.99c-.93-.61-2.91-.17-4.08-1.18 1.13 1.29 3.3.75 4.29 1.4.06.04.1.09.15.14-.09-.14-.21-.26-.36-.36zm-1.77-4.73c.22-.01.41.1.59.24-.22-.26-.49-.48-.8-.46-.75.03-1.12.68-.86 1.21.08.17.21.29.35.4-.05-.06-.1-.11-.14-.19-.26-.51.11-1.16.86-1.2zm3.35.21-2.18.8.12.25 2.27-.83c-.17-.7-.55-1.23-1.03-1.6.38.36.68.8.82 1.38zm-2.96 6.41c-.41-.5-.61-1.12-.61-1.12l-.11.05c.13.3.37.74.72 1.07zm3.84-3.26a2.09 2.09 0 0 0-.66-.72c.16.15.33.29.45.5.66 1.19.82 3.02.2 4.14s-3.08 2.23-4.78 1.44c-.39-.18-.69-.4-.95-.64.29.32.66.62 1.16.86 1.7.79 4.16-.32 4.78-1.44.62-1.11.47-2.95-.2-4.14z",
    fill: "#b30000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.29 17.99a1.19 1.19 0 0 0 .41.48c-.07-.08-.13-.14-.2-.26-.43-.82-1.05-5.1-1.05-5.1l-.17.05c.15.93.65 4.13 1.01 4.83zm1.98 1.03s-.46 1.74-1.96 1.75c-.63 0-1.11-.23-1.48-.58.39.48.94.8 1.7.8 1.12-.01 1.66-.97 1.86-1.46l-.12-.51zm.95-6.62-.16.06 1.47 7.4-1.85.23.05.24 2.02-.25z",
    fill: "#c01a09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72 16.91c-.1-.11-.21-.21-.31-.35l-.32-1.77c.11-.4.4-1.2.94-1.31.22-.04.42.05.62.21-.24-.3-.53-.48-.83-.42-.54.11-.83.91-.94 1.31l.32 1.77c.17.23.35.41.52.56zm-1.12-3.83c.04-.09.09-.17.13-.25l-.19-1.06-.17.05.23 1.26zm4.31.01a3.84 3.84 0 0 0-.71-1.05c.17.23.34.5.49.83.85 1.81.71 4.26.23 5.33-.64 1.41-2.51 1.21-3.37.12l.69 3.81-2.11.2.04.24 2.29-.22-.69-3.81c.86 1.08 2.74 1.28 3.37-.12.48-1.06.63-3.51-.23-5.33z",
    fill: "#ba350b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.79 14.45-4.55.44s.18 1.06.76 1.53c-.41-.52-.55-1.31-.55-1.31l4.55-.44c-.04-1.74-.57-2.91-1.3-3.61.63.72 1.06 1.82 1.09 3.39zm-3.11 3.67c-1.2.06-2.05-.33-2.64-.93.59.74 1.51 1.22 2.86 1.15 2.65-.15 3.07-2.52 3.07-2.52l-.28.02c-.18.59-.85 2.16-3.01 2.28zm-1.4-4.45c-.06-.36-.09-1.04.41-1.46a1.02 1.02 0 0 1 1.36-.01c-.46-.56-1.11-.61-1.58-.21-.7.59-.36 1.7-.36 1.7l.17-.02z",
    fill: "#bd4c14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.39 10.77.17-.3-.08-.8-.19.04.1 1.06zm2.42-1.08-.51 2.13c-.77-.67-1.41.24-1.59.92l.31 4.61-2.15.03.01.22 2.35-.03-.31-4.61c.19-.69.82-1.59 1.59-.92l.53-2.19c-.08-.08-.15-.11-.23-.16z",
    fill: "#c06319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.24 8.41-4.18.11.11 1.91.2-.02-.09-1.68 4.17-.1-.04-2.25-.21.01zm.41 6.37-.22.01.03 2.16h-6.44l.01.22h6.64zm-4.52-.04.22-.01.01-2.11 3.87-.08-.04-2.18-.21.02.04 1.94-3.87.09z",
    fill: "#c3791d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.75 10.19c-.12-.22-.29-.39-.48-.53.09.1.2.19.27.31.5.9.31 3.97.15 6.92l-2.01.02-.01.22 2.23-.02c.16-2.96.35-6.03-.15-6.92zm-3.89.53c.06-.09.15-.19.22-.28l.01-1.13-.22.03-.01 1.38zm1.01.54c-.49-.03-.69.3-.92.75l-.18 4.98h-2.09l-.01.22h2.32l.18-4.98c.23-.44.43-.78.92-.75.09.01.15.05.22.09-.11-.18-.23-.3-.44-.31z",
    fill: "#c88a20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.43 11.39c.22 0 .39.07.54.19-.17-.22-.41-.4-.75-.4-.88 0-1.1.92-1.1.92l-1.7-.45c-.02.05-.06.09-.08.14l2 .53c-.02-.01.2-.93 1.09-.93zm-1.23 4.54c-.18-.3-.23-.68-.03-1.02.36-.59 1.49-.81 1.84-.86a.973.973 0 0 0-.11-.23s-1.52.18-1.94.88c-.27.43-.1.93.24 1.23zm1.7.79s-1.02.76-1.84.87a2.32 2.32 0 0 1-1.8-.49c.03.03.04.08.07.1.45.44 1.13.71 1.94.61.61-.08 1.33-.52 1.65-.74-.03-.23-.02-.35-.02-.35zm1.82-6.4c-.03-.03-.08-.05-.11-.08.85 1.03.65 2.9.44 4.76-.22 1.94-.02 2.68-.02 2.68l-1.79-.09c.08.2.15.21.15.21l1.85.09s-.19-.74.02-2.68c.23-1.93.44-3.89-.54-4.89z",
    fill: "#cb9d27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.38 7.53-1.09 10.5-2.05-.15-.02.2 2.28.17 1.11-10.72zm3.06 9.21c-.28-.31-.46-.8-.43-1.53.04-.73.19-1.55.62-2.01.31-.33.74-.45 1.11-.21-.39-.51-.95-.41-1.33-.01-.43.46-.58 1.28-.62 2.01-.04.91.24 1.49.65 1.75zm2.93-5.25c1.15 1.25.92 3.44.76 4.04-.21.77-.38 1.77-1.6 2.73-1.01.8-2.82.75-3.83-.21.95 1.17 2.96 1.28 4.05.42 1.21-.96 1.39-1.96 1.6-2.73.16-.63.42-3.06-.98-4.25z",
    fill: "#d1b22c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.67 20.02c-.27-.33-.43-.84-.32-1.59.1-.72.34-1.45.81-1.88.33-.3.77-.35 1.1-.13-.33-.47-.91-.46-1.32-.09-.47.43-.71 1.15-.81 1.88-.12.94.14 1.54.54 1.81zm3.28-5.08c1.1 1.33.66 3.54.45 4.14-.27.75-.53 1.73-1.82 2.59-.97.64-2.53.56-3.52-.22.95.96 2.68 1.13 3.73.43 1.29-.86 1.56-1.84 1.82-2.59.23-.62.71-3.06-.66-4.35z",
    fill: "#eed934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.16 12 .25.04.55-2.66-.3.17-.5 2.45zm-2.4 1.74-.69-.12-.06.17.71.13c.01-.07.03-.13.04-.18zm2.34 6c-1.22.32-1.98.19-2.43-.19.41.56 1.21.78 2.64.41l.21-1.86c-.1.03-.16.01-.24.02l-.18 1.62zm1.32-7.38L74 14.32l-1.25-.22c-.13.68-.85 3.21-.09 3.72-.4-.82.19-2.9.31-3.51l1.25.22.46-2.14-.26-.03z",
    fill: "#d4c530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.22 12.9.26.05.69-2.6-.32.15-.63 2.4zm-3.21 1.6-.05.16.65.15.04-.16-.64-.15zm2.8 6.12c-1.2.27-1.95.13-2.39-.25.4.55 1.19.79 2.61.47l.28-1.86c-.1.03-.17.01-.25.02l-.25 1.62zm1.58-7.33-.52 2.08-1.21-.27c-.16.66-.97 3.12-.22 3.62-.38-.8.29-2.81.43-3.4l1.21.27.57-2.25-.26-.05z",
    fill: "#e8dd63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m10.15 15.53 2.28-.68s.62 4.27 1.05 5.1.96.65 1.31.39c.35-.27.41-.45.2-1.58l-.92-3.92 2.12-.68 1.53 7.67-2.02.25-.24-1.09s-.46 1.74-1.96 1.75c-1.51.01-2.2-1.29-2.44-2.51l-.91-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m34.45 11.42-2.05.45.46 7.48 2.35-.03-.31-4.61c.19-.69.82-1.59 1.59-.92l.53-2.19c-1.07-1.02-2.01.32-2.44 1.15l-.13-1.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m70.98 15.52.96.17c-.46 2.56-2.12 7.16 2.34 6l.21-1.86c-1.78.61-.73-2.96-.57-3.78l1.25.22.46-2.14-1.3-.18.59-2.84c-.63.37-1.59.89-2.4 1.21l-.24 1.35-.66-.1-.64 1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M78.99 22.58c-4.47.99-2.72-3.5-2.15-5.98l-.91-.2.69-2.03.71.12.31-1.3 2.51-1.1-.74 2.77 1.21.21-.57 2.25-1.21-.27c-.19.79-1.36 4.23.43 3.68l-.28 1.85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalySuperenalotto);
export default __webpack_public_path__ + "static/media/italy_superenalotto.72cb82365f7c3e2af463e95125c2d8fb.svg";
export { ForwardRef as ReactComponent };